export default __webpack_public_path__ + "static/media/placeholder-image.125be2c2.svg";